import React from "react";
import WorkstepLogo from "common/DS/WorkstepLogo";
import { H6 } from "common/DS/Text";
import { ContainedButton } from "common/DS/Buttons";
import classes from "classnames";
import ReactionPicker from "common/DS/ReactionPicker";
import { Reaction } from "workstep/pages/Feedback/Comments/state/types";

type Props = {
    subject: string;
    body: string;
    logo: Maybe<string>;
    checkinUrl: Maybe<string>;
    className?: string;
    extraLinks?: React.ReactNode[];
    onReact?: (reaction: Maybe<Reaction>) => void;
    reactionLoading?: boolean;
    reaction?: Maybe<Reaction>;
    enableReactions?: boolean;
};

export default function MessageDisplay({
    subject,
    body,
    logo,
    checkinUrl,
    className,
    extraLinks,
    onReact = () => undefined,
    reactionLoading = false,
    reaction,
    enableReactions = false,
}: Props) {
    let checkinLinkProps;

    if (checkinUrl) {
        checkinLinkProps =
            checkinUrl === "#"
                ? {
                      onClick: () => undefined,
                  }
                : {
                      href: checkinUrl,
                  };
    }

    return (
        <div className={classes("inform-message-preview", className)}>
            <div className="inform-message-preview__message">
                <div className="inform-message-preview__message__body">
                    {logo && (
                        <div className="inform-message-preview__message__logo">
                            <img
                                width="170"
                                src={logo}
                                alt="Company Logo"
                                style={{ width: "170px" }}
                            />
                        </div>
                    )}
                    <H6>{subject}</H6>
                    <div
                        className="inform-message-preview__message__text"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: body }}
                    />
                    {checkinLinkProps && (
                        <div className="center">
                            <ContainedButton {...checkinLinkProps}>
                                Take me to the survey
                            </ContainedButton>
                        </div>
                    )}
                </div>
                {enableReactions && (
                    <div className="flex flex-row flex-jsa m-md">
                        <ReactionPicker
                            onChange={onReact}
                            disabled={reactionLoading}
                            reaction={reaction}
                        />
                    </div>
                )}
                <div className="inform-message-preview__footer">
                    <div className="inform-message-preview__footer__container">
                        <div className="inform-message-preview__footer__group">
                            <div className="inform-message-preview__footer__links">
                                <a href="/terms">Terms</a>
                                <a href="/privacy">Privacy</a>
                                {extraLinks}
                            </div>
                            <div className="inform-message-preview__footer__address">
                                535 Mission Street, Fl14, San Francisco, CA 94105
                            </div>
                        </div>
                        <WorkstepLogo />
                    </div>
                </div>
            </div>
        </div>
    );
}
